// reducers/connect/cannedResponses.js

// --- GET ---

export function cannedResponsesGetHasErrored(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_GET_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function cannedResponsesGetIsLoading(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_GET_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function cannedResponsesGet(state = [], action) {
  switch(action.type) {
    case  'CANNED_RESPOSNES_GET_FETCH_DATA_SUCCESS':
      return action.list;
    default:
      return state;
  }
}

// --- ADD ---

export function cannedResponsesAddHasErrored(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_ADD_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function cannedResponsesAddIsLoading(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_ADD_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function cannedResponsesAdd(state = {}, action) {
  switch(action.type) {
    case  'CANNED_RESPOSNES_ADD_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}

// --- UPDATE ---

export function cannedResponsesUpdateHasErrored(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_UPDATE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function cannedResponsesUpdateIsLoading(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_UPDATE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function cannedResponsesUpdate(state = {}, action) {
  switch(action.type) {
    case  'CANNED_RESPOSNES_UPDATE_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}

// --- DELETE ---

export function cannedResponsesDeleteHasErrored(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_DELETE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function cannedResponsesDeleteIsLoading(state = false, action) {
  switch (action.type) {
    case 'CANNED_RESPONSES_DELETE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function cannedResponsesDelete(state = {}, action) {
  switch(action.type) {
    case  'CANNED_RESPOSNES_DELETE_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}